import {Injectable} from '@angular/core';
import {Options} from "highcharts";
import moment from 'moment-timezone';

declare module 'highcharts' {
  interface SeriesColumnOptions {
      borderRadiusTopLeft?: number
      borderRadiusTopRight?: number
  }
}

@Injectable({
  providedIn: 'root'
})
export class TrendChartService {

  public static getOptions(
    data, y_min, y_max, height, width, backgroundColor, stop_0_color, stop_1_color, colors, format,
    title: Highcharts.TitleOptions = {text: ''},
    subtitle: Highcharts.SubtitleOptions = {text: ''},
    tooltip: Highcharts.TooltipOptions = {enabled: false},
    legend: Highcharts.LegendOptions = {enabled: false},
    series: Array<Highcharts.SeriesOptionsType> = [{type: "area"}],
    xAxisDivider?: boolean
  ) {

    let options: Options = {
      chart: {
        zooming: {type: "x"},
        backgroundColor: backgroundColor,
        height: height,
        reflow: true
      },
      legend: legend,
      credits: {
        enabled: false
      },
      title: title,
      subtitle: subtitle,
      tooltip: tooltip,
      xAxis: {
        lineColor: '#ccd6eb',
        tickColor: '#ccd6eb',
        type: 'datetime',
        minPadding: 0,
        tickPixelInterval: 160,
        title: {
          text: ''
        },
        labels: {
          formatter: function () {
            return moment(this.value).format();
          }
        }
      },
      yAxis: {
        title: {
          text: ''
        },
        labels: {
          style: {
            fontSize: '11px',
            fill: '#666666',
            color: '#666666',
            fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif'
          }
        },
        min: y_min,
        max: y_max,
        tickInterval: 20,
        gridLineWidth: 0,
        lineColor: '#f8f9fa',
        lineWidth: 1,
        maxPadding: 0,
        minPadding: 0
      },
      plotOptions: {
        area: {
          fillColor: {
            linearGradient: {x1: 1, y1: 0, x2: 1, y2: 1},
            stops: [
              [0, stop_0_color],
              [1, stop_1_color]
            ]
          },
          marker: {
            enabled: false
          },
          enableMouseTracking: false,
          threshold: -100
        }
      },
      colors: colors,
      series: series,
    };

    if (xAxisDivider===true) {
      (options.yAxis as Highcharts.YAxisOptions).plotLines = [{
          color: 'rgb(204, 214, 235)',
          width: 1,
          value: 0,
          zIndex: 5
      }];
    }

    this.setChartOptionsFromData(options, data, format)
    return options;
  }

  public static setChartOptionsFromData(chartOptions, data, format, backgroundColor?, stop_0_color?, stop_1_color?, color?) {
    let marker_enabled = false, label_format = '';
    if (data.length < 2) {
      marker_enabled = true;
    }

    if (format == 'years') {
      label_format = 'YYYY';
    } else if (format == 'quarters') {
      label_format = '[Q]Q, YYYY';
    } else if (format == 'months') {
      label_format = 'MMM, YYYY';
    } else if (format == 'pulse_months') {
      label_format = 'MMMM YYYY';
    } else if (format == 'weeks') {
      label_format = '[W]W, YYYY';
    } else if (format == 'pulse_weeks') {
      label_format = 'D MMM YYYY'
    }
    else if (format == 'pulse_days' || format == 'dates') {
      label_format = 'DD MMM YYYY';
    }
    else {
      label_format = 'L';
    }

    // @ts-ignore
    chartOptions.xAxis.labels = {
      formatter: function () {
        if (format == 'pulse_weeks') {
          return moment(this.value).startOf('isoWeek').format(label_format)
        }
        return moment(this.value).format(label_format);
      },
      style: {
        fontSize: '11px',
        fill: '#666666',
        color: '#666666',
        fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif'
      }
    };

    chartOptions.plotOptions.area.marker.enabled = marker_enabled;
    chartOptions.series[0].data = data;

    if (backgroundColor) {
      chartOptions.chart.backgroundColor = backgroundColor;
    }
    if (stop_0_color && stop_1_color) {
      chartOptions.plotOptions.area.fillColor.stops = [
        [0, stop_0_color],
        [1, stop_1_color]
      ]
    }
    if (color) {
      chartOptions.colors = [color];
    }
  }
}
